import type { NectarPageBlock } from '~/utils/nectarPageBlock';
import { NECTAR_PAGE_BLOCK_GET_PARAM_NAME } from '~/utils/nectarTrackingFields';

export const buildUpgradeUrl = (premiumOfferId: string | null | undefined, pageBlock?: NectarPageBlock): string => {
  const params = new URLSearchParams();
  if (premiumOfferId) params.set('offer_id', premiumOfferId);
  if (pageBlock) params.set(NECTAR_PAGE_BLOCK_GET_PARAM_NAME, pageBlock);

  const query = params.toString();
  return query ? `/upgrade?${query}` : '/upgrade';
};
